import React from 'react'
import { DatabaseViewer } from '@components/database/DatabaseViewer'
import { Header } from '@components/layout/Header'
import { Footer } from '@components/layout/Footer'
import { useTheme } from '@hooks/useTheme'

function App() {
  const { currentTheme } = useTheme()

  return (
    <div className={`min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900 ${currentTheme === 'dark' ? 'dark' : ''}`}>
      <Header />
      <main className="container mx-auto px-4 py-8 flex-1">
        <DatabaseViewer />
      </main>
      <Footer />
    </div>
  )
}

export default App 